import { ReactNode } from 'react'

interface PageHeaderProps {
    title: string
    description: string | ReactNode
    action?: ReactNode
    children?: ReactNode
}

export default function PageHeader({
    title,
    description,
    action,
    children
}: PageHeaderProps) {
    return (
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 pb-6 border-b-2 border-primary/5">
            <div className="space-y-4">
                <h1 className="text-3xl md:text-4xl font-black text-primary tracking-tighter uppercase italic leading-[0.9] drop-shadow-sm">
                    {title}
                </h1>
                <div className="premium-text max-w-2xl italic">
                    {description}
                </div>
            </div>
            {(action || children) && <div className="flex items-center gap-4">{action || children}</div>}
        </div>
    )
}
